function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#qwick-i_svg__filter0_d)"
}, React.createElement("circle", {
  cx: 54,
  cy: 52,
  r: 50,
  fill: "#09314C"
}), React.createElement("path", {
  fill: "url(#qwick-i_svg__pattern0)",
  d: "M38 17h32.138v70H38z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("pattern", {
  id: "qwick-i_svg__pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, React.createElement("use", {
  xlinkHref: "#qwick-i_svg__image0",
  transform: "scale(.0137 .00629)"
})), React.createElement("filter", {
  id: "qwick-i_svg__filter0_d",
  x: 0,
  y: 0,
  width: 108,
  height: 108,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 2
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0295189 0 0 0 0 0.137798 0 0 0 0 0.187773 0 0 0 0.24 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("image", {
  id: "qwick-i_svg__image0",
  width: 73,
  height: 159,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAACfCAYAAAC1FPTuAAAACXBIWXMAAAsSAAALEgHS3X78AAAEj0lEQVR42u2dPXbaQBSFL3Pcm6zAygqMG9Mpcqcu8gqirCB4BSErCF5BxApiV6YUdKpiVhC8gpgVOAVDToz5kUYjzRO69xwXjo+I+Lh39ObNIHVeXl4gQf3JLAAQ6F8fs9C/gxB1JEDqT2ZDAF83/nmchX5MSCtAPQC/dvz5cxb6iWtISsAHtc8tkQQnSYC0D8TH/mTWbTUkHbWzEhBb4aS4pNNaASkPAOeRU8KjJsJNSnjUWg+pyBt3GjnlKGpegag5d5NqgIvWCtoGKa4JbDMh6aidGxx62p/MorY4KXJ0bKMgxYRUTdScRk41KGrO3KQaFLXjh2Qhas4iV6eTAmGxza1aetx63vVoMBXZpSWAXhb6i6Nwkm6JpBYBAcApgFQvQ9XjJJ3xoaUx4xj0BCDJQn8IAJ3Lh2kE4Ce5bNW3LPSHncuH6cJyFI5N7xQBHVRP6SsFtVsLBSAhh52aZqG/UPqqdk8ebzRfF63/isn+ZDbQwE7JZ3VV21px68IvaXG9tAQQZaGf7qy4s9B/1HOs2xYCugfgbQLaO3fTVXjSkvjdZKE/Mprg6vZGAuDDEQ/OsU5QuS7Aju16TdcYwCAL/edcE9wCs/m7I6jQl9o9uTeu5m6VaEv2Gl5TzbHqQxXa2WvUdOtPZjGAUcMG9Ve1T+WQGlZTba19aoH0H6wRgC+Ca584z+BcKaT/4vejSbVP7ZAElgnTLPQDWy9mcyEgFeSixOaLKRynulIhRYIgBYR0WFY3olqBVHBPdl2KpDkpFjguiYMUCIRkLXLKQtQ8wVOTSIqTIshVIAVSLBiSeycJjxpgaVecOuKoWTvHE0FRW2LVHn7Wb+xMCqQyTTcPwG9Lb+RN38dyn+q6zM0YlOOoLbHq+0SbjbEs9AcArmFn10upc1UOozYHEOxrjOlP3wMwdQnJdCGgC+BPif/3FsCwSFtVb+j47iJyquZPZqlPdlC076wdd4HVps9a3VQnpCkM1rw2QK3X/sZ1Vt+F42YYNeM1rz3nEaP42t/FoXV/W04q4qInAFe2AWlXJdpV86ovNiaQvAK1T6/MomAOUIss9HvIv5+q52qCm7v2qRDWAMAVKtpJbAIpLVP7VAgqzVFTGV00TOukbVOGwrVPVdpRUxnf/qzshon1IH5nctWoGJSnz68LIHW6YaINUkRASIRESIRESIRESBQhERIhudWJoHMJNn5f6J/WQ/Kw+t5vhO296jlWfezE5Um67ALEyN/In2qQz22CFKP41yzmMOxRN3Hg9rSDiurc8LhGOikB8KnE8e/rHtCbdjNOG8eLhxSg/LctAxaTh9UlJE5LCImQCIkiJEIiJEIiJEIiJIqQCImQCImQCImQKEIiJEIiJEIiJEIiJIqQCImQCImQCImQKEIiJEIiJEIiJEIiJCIgJEIiJEIiJEIiJIqQCImQCImQCImQKEIiJEIiJEIipFxaCHkN8ZCeSr5G2oa4JSWOXcLB7RRdQBqVcFPcloF7/UzJok+rGcPw4SxNvbqtH0E2zxmxGzh83q6E55bE2lkBXt8Ub66dk8DxPXD/AiCtkYBYrbFNAAAAAElFTkSuQmCC"
}));

function SvgQwickI(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgQwickI;